export default __webpack_public_path__ + "static/media/queue.0f696612.png";